import React from 'react';
import { Translate } from '../../config/TranslationProvider';
import { isAbsoluteUrl } from '../../helper';

const Contact = ({ host: { telephone, email, url, contact_person, location } }) => {
    if (!url && !location && !telephone && !contact_person && !email) {
        return null;
    }

    let absoluteUrl = '';
    if (url) {
        const href = url;
        absoluteUrl = isAbsoluteUrl(href) ? href : 'http://' + href;
    }

    return (
        <div className="widget atbd_widget widget-card">
            <div className="atbd_widget_title">
                <h2 className="h4"><span className="la la-user" />&nbsp;<Translate value="contact" /></h2>
            </div>

            <div className="widget-body atbd_author_info_widget">
                <div className="atbd_widget_contact_info">
                    <ul>
                        {location && (
                            <li>
                                <span className="la la-map-marker" />
                                <span className="atbd_info">{location.address}</span>
                            </li>
                        )}
                        {telephone && (
                            <li>
                                <span className="la la-phone" />
                                <span className="atbd_info">{telephone}</span>
                            </li>
                        )}
                        {contact_person && (
                            <li>
                                <span className="la la-user" />
                                <span className="atbd_info">{contact_person}</span>
                            </li>
                        )}
                        {email && (
                            <li>
                                <span className="la la-envelope" />
                                <span className="atbd_info">
                                    <a href={'mailto:' + email} >{email}</a>
                                </span>
                            </li>
                        )}
                        {url && (
                            <li>
                                <span className="la la-globe" />
                                <a
                                    target="_blank"
                                    href={absoluteUrl}
                                    rel="noopener noreferrer"
                                    className="atbd_info"
                                >
                                    {url}
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Contact;
